import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/bankIcons/sbp.svg'
import _imports_1 from '@/assets/bankIcons/sber.svg'


const _withScopeId = n => (_pushScopeId("data-v-34f3d324"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "СБП", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "PAY", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "КАРТА", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.paymentMethod === 'sbp')
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          dark: "",
          loading: _ctx.waitPayment
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              class: "q-mr-sm",
              size: "20px"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    (_ctx.paymentMethod === 'deep')
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          dark: "",
          loading: _ctx.waitPayment,
          style: {"color":"white"},
          class: "sberBtn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              class: "q-mr-sm",
              size: "20px"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    (_ctx.paymentMethod === 'card')
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 2,
          loading: _ctx.waitPayment,
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "credit_card",
              class: "q-mr-sm",
              size: "20px"
            }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true)
  ]))
}